function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Creator-2.0",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ingredients---Empty-1",
  transform: "translate(-643.000000, -541.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Containers-Empty",
  transform: "translate(260.000000, 464.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(383.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "No-Account",
  transform: "translate(0.000000, 21.794872)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M154,78.2051282 C154,35.7217949 119.525817,1.28205128 77,1.28205128 C34.4741833,1.28205128 0,35.7217949 0,78.2051282 L154,78.2051282 Z",
  id: "Fill-2",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "recipe_category_food_type_one_pot_meals",
  transform: "translate(34.650000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.0291667,16.4844143 C37.9925393,16.4844143 34.7197464,14.0245733 34.7197464,10.9896095 C34.7197464,7.95464569 37.9925393,5.49480476 42.0291667,5.49480476 C46.065794,5.49480476 49.338587,7.95464569 49.338587,10.9896095 C49.338587,14.0245733 46.065794,16.4844143 42.0291667,16.4844143 M42.0291667,0 C34.964612,0 29.2376812,4.92151346 29.2376812,10.9896095 C29.2376812,17.0577056 34.964612,21.979219 42.0291667,21.979219 C49.0937214,21.979219 54.8206522,17.0577056 54.8206522,10.9896095 C54.8206522,4.92151346 49.0937214,0 42.0291667,0",
  id: "Shape",
  fill: "#003333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.30942029,29.1352438 L76.748913,29.1352438 C80.7855404,29.1352438 84.0583333,25.0156737 84.0583333,19.9346405 L0,19.9346405 C0,25.0156737 3.27279293,29.1352438 7.30942029,29.1352438 M18.5724295,10.7340372 L65.9984547,10.7340372 C70.0278428,10.7340372 73.2947663,14.8536073 73.2947663,19.9346405 L11.2761179,19.9346405 C11.2761179,14.8536073 14.5430414,10.7340372 18.5724295,10.7340372",
  id: "Shape",
  fill: "#339999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.7847826,78.2051282 L18.2735507,78.2051282 C14.2369234,78.2051282 10.9641304,74.1771041 10.9641304,69.2089827 L10.9641304,19.7301827 L73.0942029,19.7301827 L73.0942029,69.2089827 C73.0942029,74.1771041 69.82141,78.2051282 65.7847826,78.2051282",
  id: "Path",
  fill: "#003333"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.34166667,32.0512821 L8.34166667,46.1538462 C8.34166667,61.7314103 20.9818583,74.3589744 36.575,74.3589744 L39.0742917,74.3589744 C49.7426417,74.3589744 58.3916667,65.7185897 58.3916667,55.0608974 L58.3916667,32.0512821 L8.34166667,32.0512821 Z",
  id: "Fill-4",
  fill: "#58595B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.4666667,28.2051282 L10.2666667,28.2051282 C8.140825,28.2051282 6.41666667,29.9275641 6.41666667,32.0512821 L60.3166667,32.0512821 C60.3166667,29.9275641 58.5925083,28.2051282 56.4666667,28.2051282",
  id: "Fill-14",
  fill: "#BBBDBF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9083333,70.5128205 C9.49089167,70.5128205 8.34166667,71.6608974 8.34166667,73.0769231 L8.34166667,78.2051282 L35.2916667,78.2051282 L35.2916667,70.5128205 L10.9083333,70.5128205 Z",
  id: "Fill-19",
  fill: "#CC9966"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.375,70.5128205 L30.1583333,70.5128205 C28.7408917,70.5128205 27.5916667,71.6608974 27.5916667,73.0769231 L27.5916667,78.2051282 L69.9416667,78.2051282 L69.9416667,73.0769231 C69.9416667,71.6608974 68.7924417,70.5128205 67.375,70.5128205",
  id: "Fill-22",
  fill: "#996633"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7237167,66.6666667 C31.11185,66.6666667 29.61035,65.6474359 29.0726333,64.0358974 L21.3739167,40.9602564 C20.70145,38.9455128 21.7916417,36.7673077 23.8077583,36.0961538 C25.8270833,35.425 28.0049,36.5128205 28.6773667,38.5282051 L36.3760833,61.6038462 C37.04855,63.6185897 35.9583583,65.7967949 33.9416,66.4679487 C33.5379917,66.6025641 33.127325,66.6666667 32.7237167,66.6666667",
  id: "Fill-33",
  fill: "#339999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.7666667,47.4358974 L21.8166667,47.4358974 C19.690825,47.4358974 17.9666667,49.1583333 17.9666667,51.2820513 L17.9666667,55.1282051 C17.9666667,63.625 24.861375,70.5128205 33.3666667,70.5128205 L37.2166667,70.5128205 C45.7219583,70.5128205 52.6166667,63.625 52.6166667,55.1282051 L52.6166667,51.2820513 C52.6166667,49.1583333 50.8925083,47.4358974 48.7666667,47.4358974",
  id: "Fill-34",
  fill: "#CCFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.383333,47.4358974 L98.8166667,47.4358974 C95.2785167,47.4358974 92.4,50.3115385 92.4,53.8461538 L92.4,61.5384615 C92.4,62.9544872 93.549225,64.1025641 94.9666667,64.1025641 C96.3841083,64.1025641 97.5333333,62.9544872 97.5333333,61.5384615 L97.5333333,53.8461538 C97.5333333,53.1391026 98.1089083,52.5641026 98.8166667,52.5641026 L101.383333,52.5641026 C102.800775,52.5641026 103.95,51.4160256 103.95,50 C103.95,48.5839744 102.800775,47.4358974 101.383333,47.4358974",
  id: "Fill-35",
  fill: "#339966"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.958333,60.2564103 L116.141667,60.2564103 L116.141667,62.8205128 L140.525,62.8205128 C140.525,61.4044872 139.375775,60.2564103 137.958333,60.2564103",
  id: "Fill-36",
  fill: "#FF9999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.025,62.8205128 L102.025,66.6666667 C102.025,73.0391026 107.196192,78.2051282 113.575,78.2051282 L127.691667,78.2051282 C134.070475,78.2051282 139.241667,73.0391026 139.241667,66.6666667 L139.241667,62.8205128 L102.025,62.8205128 Z",
  id: "Fill-37",
  fill: "#CC6666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.766667,73.0769231 C125.766667,75.9089744 123.468217,78.2051282 120.633333,78.2051282 L105.233333,78.2051282 C102.39845,78.2051282 100.1,75.9089744 100.1,73.0769231 L100.1,47.4358974 L125.766667,47.4358974 L125.926547,47.4383379 C128.687466,47.5227355 130.9,49.7854862 130.9,52.5641026 C128.118605,52.5641026 125.853592,54.7744265 125.76911,57.5325871 L125.766667,57.6923077 L125.766667,73.0769231 Z",
  id: "Path",
  fill: "#66CC99"
}))))));

function SvgContainersEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "154px",
    height: "79px",
    viewBox: "0 0 154 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration/Containers empty state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainersEmptyState);
export default __webpack_public_path__ + "static/media/containers-empty-state.233284a0.svg";
export { ForwardRef as ReactComponent };